import React from "react";
import ReactDOM from "react-dom/client";
import "./css/styles.css";
import About from "./components/About";
import App from "./components/App";
import Visit from "./components/Visit";
import axios from "axios";
import { ThemeProvider, createTheme } from "@mui/material";
import { BrowserRouter, Routes, Route } from "react-router-dom";

axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";

const THEME = createTheme({
	typography: {
		fontFamily: `"Arial Nova", sans-serif`,
	},
	palette: {
		primary: {
			main: "#3b4559",
		},
		secondary: {
			main: "#E8666D",
		},
	},
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<ThemeProvider theme={THEME}>
		<BrowserRouter>
			<Routes>
				<Route path="/about" element={<About />} />
				<Route path="/visit" element={<Visit />} />
				<Route path="/" element={<App />} />
			</Routes>
		</BrowserRouter>
	</ThemeProvider>

	// </React.StrictMode>
);
